export default "__VITE_ASSET__Bnlr4FQ6__"